import { render } from "./Footer.vue?vue&type=template&id=2e0ed5b9&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=2e0ed5b9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/_vue_us_stage_azure_v24042026_02/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0ed5b9"]])

export default __exports__